export default "<figure>\n  <div>\n    <img src=\"../../../assets/images/like.svg\">\n  </div>\n</figure>"